// @ts-strict-ignore
import {AfterViewInit, Component, Injector, OnInit, QueryList, ViewChildren} from "@angular/core";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ExamFlow, ExamPhase, SessionPhaseType} from "@models";
import {MatExpansionPanel} from "@angular/material/expansion";
import {EnumLabel} from "../../../../../shared/shared-pipes/enum-label.pipe";
import {PhaseColorMapping} from "../../../../../shared/models/SimSessionPhasePalette";

export interface DialogData_PhaseInfoDialogInput extends MatDialogDataBaseInput {
	examFlow: ExamFlow;
}

@Component({
	selector: "sim-phase-info-dialog",
	templateUrl: "./phase-info-dialog.component.html",
	styleUrl: "./phase-info-dialog.component.scss",
	standalone: false,
})
export class PhaseInfoDialogComponent
	extends BasicMaterialDialog<PhaseInfoDialogComponent, DialogData_PhaseInfoDialogInput>
	implements OnInit, AfterViewInit
{
	public activePhases: ExamPhase[];
	@ViewChildren("phasePanel") phasePanels: QueryList<MatExpansionPanel>;

	// Readonly
	protected readonly Number = Number;
	protected readonly SessionPhaseType = SessionPhaseType;
	protected readonly Math = Math;
	protected readonly EnumLabel = EnumLabel;
	protected readonly PhaseColorMapping = PhaseColorMapping;

	constructor(_injector: Injector) {
		super(_injector);
	}

	public ngOnInit() {
		this.activePhases = this.data.examFlow.examPhases.filter((examPhase) => examPhase.isActive);
	}

	public ngAfterViewInit() {
		this.phasePanels?.get(0)?.open();
	}

	public collapseOtherPhases(panelId: string): void {
		this.phasePanels.forEach((panel: MatExpansionPanel) => {
			if (panel.id !== panelId) panel.close();
		});
	}
}
